import json from './sprite.js';

export default {
    handle: 'selwebee_spt_bookbirthday-TEST-ENGLISH',
    label: 'selwebee_spt_bookbirthday-TEST-ENGLISH',
    json,
};
